import { INSURANCE_VALIDATION_CHANGE } from './actions';
import withInsuranceValidation from './withInsuranceValidation';

export const Actions = { INSURANCE_VALIDATION_CHANGE };
export default withInsuranceValidation;
